import i18n from '@/utils/i18n';

const fields =
    [
      {
        name: "title",
        placeholder: i18n.t('form.title_placeholder'),
        type: "text",
        label: i18n.t('form.title'),
      },
      {
        name: "name",
        placeholder: i18n.t('form.name_placeholder'),
        type: "text",
        label: i18n.t('form.name'),
      },
      {
        name: "required_auth",
        type: "checkbox",
        label: i18n.t('form.required_auth'),
      },
      {
        name: "active",
        type: "checkbox",
        label: i18n.t('form.active'),
      },
      {
        name: "status",
        type: "select",
        label: i18n.t('form.status'),
        searchable: false,
        options: [
          {
            label: i18n.t('popup_templates.draft'),
            value: 'draft'
          },
          {
            label: i18n.t('popup_templates.published'),
            value: 'published'
          }
        ],
      },
      {
        name: "version",
        type: "text",
        placeholder: i18n.t('form.version_placeholder'),
        label: i18n.t('form.version'),
      },
      {
        name: "template",
        type: "editor",
        lang: "html",
        label: i18n.t('form.template'),
      },
      {
        name: "css",
        type: "editor",
        lang: "css",
        label: i18n.t('form.css'),
      },
      {
        name: "javascript",
        type: "editor",
        lang: "javascript",
        label: i18n.t('form.javascript'),
      }
    ];

export default fields
